<div>
  <div class="row">
    <div class="col-sm-3">
      {{ 'common.start-date' | translate | titlecase }}
    </div>
    <div class="col-sm-3">
      {{ 'common.end-date' | translate | titlecase }}
    </div>
    <div class="col-sm-6"></div>
  </div>
  <div class="row">
    <div class="col-sm-2">
      <wl-date-selector name="startDate" [(ngModel)]="startDate"></wl-date-selector>
    </div>
    <div class="col-sm-2">
      <wl-date-selector name="endDate" [(ngModel)]="endDate"></wl-date-selector>
    </div>
    <div class="col-sm-4">
      <select class="form-control" [(ngModel)]="selectedGatewayId" (ngModelChange)="onGatewayChange($event)">
        <option *ngFor="let gateway of cardConnectGateways" [value]="gateway.CCGatewayID">
          {{ gateway.Name }}
        </option>
      </select>
    </div>
    <div class="col-sm-2">
      <button pButton type="button" class="btn btn-primary" (click)="searchFundingTransactions()">{{ 'common.search' | translate | titlecase
        }}</button>
    </div>
    <div class="col-sm-2">
      <button pButton type="button" class="btn btn-primary" (click)="processCreditCard()">
        {{ 'integrations.card-connect.card-connect-trans.process-card-with-no-system-transaction' | translate |
        titlecase }}
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-3"></div>
    <div class="col-sm-3"></div>
    <div class="col-sm-6"></div>
  </div>

  <p-table [showGridlines]="true" #fundingTransactionsDataGrid [value]="fundingTransactionsResponse.txns" [rows]="99999">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th [pSortableColumn]="'cardtype'">
          {{ 'integrations.card-connect.card-connect-trans.card-type-label' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'cardbrand'">
          {{ 'integrations.card-connect.card-connect-trans.card-brand-label' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'cardnumber'">
          {{ 'integrations.card-connect.card-connect-trans.card-number-label' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'amountNumber'" class="text-right">
          {{ 'common.revenue.amount' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'currency'">
          {{ 'common.revenue.currency' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'date'" class="text-center">
          {{ 'common.date' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'retref'">
          {{ 'common.revenue.reference-number' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ item.cardtype }}</td>
        <td>{{ item.cardbrand }}</td>
        <td>{{ item.cardnumber }}</td>
        <td class="text-right">{{ item.amountNumber | currency }}</td>
        <td>{{ item.currency }}</td>
        <td class="text-center">{{ item.date | date: 'shortDate' }}</td>
        <td>{{ item.retref }}</td>
        <td>
          <button pButton type="button" class="btn btn-primary" (click)="getTransactionDetail(item.retref)">
            {{ 'common.detail' | translate | titlecase }}
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
<p-progressSpinner *ngIf="isSearching"></p-progressSpinner>

  <p-dialog #transDetail [(visible)]="showModal" modal="true" [closable]="false"
    styleClass="atlas-dialog-l" [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }">
    <ng-template pTemplate="header" show-close="true">
      <h4 class="modal-title">{{ 'integrations.card-connect.card-connect-trans.trans-detail-title' | translate |
        titlecase }}</h4>
    </ng-template>

    <div style="height:375px">
      <div class="row">
        <div class="col-sm-3">
          {{ 'common.revenue.amount' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.amount | currency }}
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          {{ 'common.revenue.reference-number' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.retref }}
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          {{ 'common.revenue.account' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.account }}
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <p-table [showGridlines]="true" scrollHeight="100%" scrollWidth="100%" [value]="selectedTransaction.InvoiceLineItems" [rows]="99999">
            <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
              <SortAltIcon *ngIf="sortOrder === 0">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
              </SortAltIcon>
              <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
              </SortAmountUpAltIcon>
              <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
              </SortAmountDownIcon>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th [pSortableColumn]="'InvoiceNum'">
                  {{ 'common.revenue.invoice-number' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Descr'">
                  {{ 'common.description' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'InvoiceDate'" class="text-center">
                  {{ 'common.revenue.invoice-date' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'DateDue'" class="text-center">
                  {{ 'common.revenue.date-due' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'AdjustedLineItemAmount'" class="text-right">
                  {{ 'common.revenue.amount' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'AdjustedAmountDue'" class="text-right">
                  {{ 'common.revenue.amount-due' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>
                  <a (click)="selectInvoice(row.InvoiceNum)">{{ row.InvoiceNum }}</a>
                </td>
                <td>{{ row.Descr }}</td>
                <td class="text-center">{{ row.InvoiceDate | date: 'shortDate' }}</td>
                <td class="text-center">{{ row.DateDue | date: 'shortDate' }}</td>
                <td class="text-right">{{ row.AdjustedLineItemAmount | currency }}</td>
                <td class="text-right">{{ row.AdjustedAmountDue | currency }}</td>
              </tr>
            </ng-template>
          </p-table>
<p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div>
        <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="this.showModal = false">Close</button>
      </div>
    </ng-template>
  </p-dialog>
</div>